import {
  StreamApp,
  StatusUpdateForm,
  FlatFeed,
  NotificationDropdown,
  Activity,
  ActivityFooter,
  LikeButton,
  CommentField,
  CommentList,
  CommentItem,
  InfiniteScrollPaginator,
} from 'react-activity-feed';

// import './compiled-all-component-styles.css';
import './about-app-styles.css';

// NAME: `T21C App - Dev`, APP ID: `1206230`, KEY: `p4ryzhnn9944`
// User `U--t21c_chair2-1` has Client side JWT token `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tdDIxY19jaGFpcjItMSJ9.JqzSnvsRp4e1r4axdiwTA6Zc9jNLkXgIj5XlwYubtb0`
// =========
// NAME: `T21C Stream UAT`, APP ID: `1173466`, KEY: `t478j3apqbjz`
// User `U--jamessalmon` has Client side JWT token `eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tamFtZXNzYWxtb24ifQ.NJpxC6p2FNPgbA4G_abWEehgJmiXgFCGvpbq8llQ8UE`
// =========

export function Store() {
  return (
    <>
      <div style={{ width: '600px', margin: '0 auto' }}>
        <StreamApp
          apiKey='p4ryzhnn9944'
          appId='1206230'
          token='eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiVS0tdDIxY19jaGFpcjItMSJ9.JqzSnvsRp4e1r4axdiwTA6Zc9jNLkXgIj5XlwYubtb0'
        >
          <h1 className='mt-4 mb-4'>Debug. No preprocessed CSS.</h1>
          <h1 className='mt-4 mb-4'>Philanthropy (Virgin Stream Pre-Coded)</h1>
          <FlatFeed
            notify
            feedGroup='user'
            userId='C--philanthropy'
            options={{
              limit: 6,
              withOwnChildren: true,
              withRecentReactions: true,
            }}
            Paginator={InfiniteScrollPaginator}
            Activity={({ activity, feedGroup, userId }) => (
              <Activity
                activity={activity}
                feedGroup={feedGroup}
                userId={userId}
                Footer={() => (
                  <>
                    <ActivityFooter
                      activity={activity}
                      feedGroup={feedGroup}
                      userId={userId}
                    />

                    <CommentList
                      activityId={activity.id}
                      CommentItem={({ comment }) => (
                        <div className='wrapper'>
                          <CommentItem comment={comment} />
                          <LikeButton reaction={comment} />
                        </div>
                      )}
                    />
                  </>
                )}
              />
            )}
          />
        </StreamApp>
      </div>
    </>
  );
}
